import { RemoveUserRoleType } from "../../types/Role";
import { del } from "../../utils/axios-config";
import { REMOVE_USER_ROLE } from "../../utils/constants";

export const removeUserRole = async (data:RemoveUserRoleType) => await del<RemoveUserRoleType,boolean>(REMOVE_USER_ROLE, data);